import {Part} from "../part";
import {PartMenuType} from "../../../visComponents/constants";
import {applianceThumbnail} from "../assets";
import DesignNavigationItem from "../../../visComponents/designNavigationItem";
import {PLACEMENTS} from "../constants";

import Fridge from "../subparts/appliances/fridge";
import FridgeShadow from "../subparts/appliances/fridgeShadow";
import Hood from "../subparts/appliances/hood";
import Dishwasher from "../subparts/appliances/dishwasher";
import Microwave from "../subparts/appliances/microwave";
import Range from "../subparts/appliances/range";

export default class Appliance extends Part {
  static id = 'Appliances';
  constructor() {
    super(true, false, PartMenuType.Complex);

    this.menuType = PartMenuType.Complex;
    this.partName = 'Appliances';
    this.partThumbnail = applianceThumbnail;
    this.partThumbnailSize = "70%";
    this.translateId = "visualizer.kitchen.appliance";

    // related items
    this.fridge = null;
    this.fridgeShadow = null;
    this.hood = null;
    this.microwave = null;
    this.range = null;
    this.dishwasher = null;
  }

  load(dbFeature) {
    let relatedItemName = "",
      shouldLoadInDifferentGroups = false,
      RelatedItemClass = null;
    switch (dbFeature.groupName) {
      case "Fridge":
        relatedItemName = "fridge";
        RelatedItemClass = Fridge;
        break;
      case "Fridge Shadow":
        relatedItemName = "fridgeShadow";
        RelatedItemClass = FridgeShadow;
        break;
      case "Hood":
        relatedItemName = "hood";
        RelatedItemClass = Hood;
        break;
      case "Dishwasher":
        relatedItemName = "dishwasher";
        RelatedItemClass = Dishwasher;
        break;
      case "Microwave":
        relatedItemName = "microwave";
        RelatedItemClass = Microwave;
        break;
      case "Range":
        // we still need to keep NotInVisualizer Ranges here
        if ((dbFeature.metaData["Placement"] && dbFeature.metaData["Placement"].includes(PLACEMENTS.Countertop)) || !dbFeature.metaData["Placement"]) {
          if (!dbFeature.metaData["Placement"]) {
            shouldLoadInDifferentGroups = true;
          }
          relatedItemName = "range";
          RelatedItemClass = Range;
        }
        break;
    }
    if (relatedItemName) {
      if (!this[relatedItemName]) {
        this[relatedItemName] = new RelatedItemClass(true);
        this.relatedItems.push(this[relatedItemName]);
      }
      if (!this.categoryEnabled) {
        this.categoryEnabled = true
      }
      this[relatedItemName].getParent = () => this;
      this[relatedItemName].load(dbFeature);
      return !shouldLoadInDifferentGroups;
    }
    return false
  }

  navigationItem() {
    return new DesignNavigationItem('Appliance', this);
  }

  isSubTypeWithItems() {
    return false;
  }

  handleSubPartClick() {

  }

}
